// extracted by mini-css-extract-plugin
var _1 = "PdfViewerSearchPanelResult-modulePdfViewerSearchPanelResult__yeKHC";
var _2 = "PdfViewerSearchPanelResult-modulematch__n0GJn";
var _3 = "PdfViewerSearchPanelResult-modulepageNumber__h0oKp";
var _4 = "PdfViewerSearchPanelResult-moduleselected__MLsVj";
var _5 = "PdfViewerSearchPanelResult-modulesnippet__Vy8dr";
export { _1 as "PdfViewerSearchPanelResult", _2 as "match", _3 as "pageNumber", _4 as "selected", _5 as "snippet" }
